export default __webpack_public_path__ + "static/media/Iwatani_Corporation_logo.f11e1c35.png";